document.querySelectorAll('.footer__link-heading').forEach(btn => {
  btn.addEventListener('click', function(evt) {
    evt.preventDefault();
    const $accordionContent = this.nextElementSibling;
    $accordionContent.classList.toggle('active');
  })
});

if (window.location.pathname.includes('collections')) {
  document.querySelector('.view-more-collection-banner').addEventListener('click', function(evt) {
    const collectionBannerWrap = document.querySelector('.boost-pfs-section-header');
    collectionBannerWrap.classList.toggle('open');
    const btnLabel = evt.target.innerText === 'View more' ? 'Close' : 'View more';
    evt.target.innerText = btnLabel;
    if (btnLabel === 'View more') {
      document.querySelector('.boost-pfs-section-header').scrollIntoView();
    }
  });
}

if (window.location.pathname.includes('size-guide')) {
  const sizeGuideColBtns = document.querySelectorAll('.fit-guide__tab-btn');
const sizeGuideColTables = document.querySelectorAll('.fit-guide__sizes-cols table');

sizeGuideColBtns.forEach(btn => {
  if (btn) {
    btn.addEventListener('click', function() {
      sizeGuideColBtns.forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      sizeGuideColTables.forEach(table => table.classList.remove('active'));
      const matchedTable = document.querySelector(`#${this.dataset.table.toLowerCase()}`);
      matchedTable.classList.add('active');
    });
  }
});
}

// Recommendations product custom JS

async function updateCartRecommendations() {
  const cartData = await getCart();

  if (cartData.item_count > 0) {
    const firstItem = cartData.items[cartData.items.length - 1];
    const recommendationsHTML = await getRecommendationsSectionHTML('recommended-products-cart', firstItem.product_id);
    // Cart recommendations
    document.querySelector('.cart-product-recommendations').innerHTML = recommendationsHTML;
    document.dispatchEvent(cartRecommendationsLoaded);
    // Purchase confirmation popup recommendations
    document.querySelector('.purchase-confirmation-popup-recommendations').innerHTML = recommendationsHTML;
    document.dispatchEvent(purchasePopupRecommendationsLoaded);
  }
}

document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
  updateCartRecommendations();
});

document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  updateCartRecommendations();
});

// Render recommendations on first load
updateCartRecommendations();

function addEventsPurchaseConfirmationPopup() {
  const $confirmationPopup = document.querySelector('.purchase-confirmation-popup');
  $confirmationPopup.classList.remove('animation--purchase-confirmation-revealed');
  $confirmationPopup.classList.remove('active');
}

async function getRecommendationsSectionHTML(sectionId, productId) {
  const response = await fetch(`/recommendations/products?product_id=${productId}&limit=5&section_id=${sectionId}`);
  return await response.text();
}

async function getCart() {
  const response = await fetch('/cart.json');
  const cartData = await response.json();
  return cartData;
}

// Read more button richtext
const $readMoreBtn = document.querySelector('.btn.read-more');
const $richtextWrapper = document.querySelector('.richtext-wrapper')

if ($readMoreBtn !== null && $richtextWrapper !== null) {
  $readMoreBtn.addEventListener('click', () => {
    $richtextWrapper.classList.toggle('open');
  });
}